import { createClient } from "@supabase/supabase-js";

const DEFAULT_SUPABASE_URL = "https://yoqhouniznljdsmpkblf.supabase.co";
// Safe fallback anon key structure to guarantee client initialization never throws uncaught errors
const DEFAULT_SUPABASE_ANON =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlvcWhvdW5pem5samRzbXBrYmxmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTE5NDI0NDgsImV4cCI6MjExNzUxODQ0OH0.dummy";

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string) || DEFAULT_SUPABASE_URL;
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || DEFAULT_SUPABASE_ANON;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: typeof window !== "undefined",
    autoRefreshToken: typeof window !== "undefined",
    detectSessionInUrl: typeof window !== "undefined",
  },
});
